module.exports = __webpack_public_path__ + "static/media/profile.4fa7524d.svg";